var _circle, _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPmInfo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "url(#paint0_linear)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.39999 9.79997C9.17318 9.79997 9.79997 9.17318 9.79997 8.39999C9.79997 7.62679 9.17318 7 8.39999 7C7.62679 7 7 7.62679 7 8.39999C7 9.17318 7.62679 9.79997 8.39999 9.79997Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.39999 15.3999C9.17318 15.3999 9.79997 14.7732 9.79997 14C9.79997 13.2268 9.17318 12.6 8.39999 12.6C7.62679 12.6 7 13.2268 7 14C7 14.7732 7.62679 15.3999 8.39999 15.3999Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.39999 20.9998C9.17318 20.9998 9.79997 20.373 9.79997 19.5998C9.79997 18.8266 9.17318 18.1998 8.39999 18.1998C7.62679 18.1998 7 18.8266 7 19.5998C7 20.373 7.62679 20.9998 8.39999 20.9998Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.667 8.4292H21.0002",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.667 14.0291H21.0002",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.667 19.629H21.0002",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 0.0000021395,
    y1: 0.682869,
    x2: 28.9758,
    y2: 1.76043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00744886,
    stopColor: "#57ADFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E78BD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPmInfo);
export default __webpack_public_path__ + "static/media/pm_info.bbd905a570ceb5bdc62752d7c036f42a.svg";
export { ForwardRef as ReactComponent };